<mat-toolbar color="accent">Review MOH Forms</mat-toolbar>

<div class="grid min-h-[80vh] grid-cols-4">
  <div class="col-span-1 flex flex-col gap-4 p-4">
    <span class="text-lg font-bold opacity-80">Complete Form Submission</span>

    <pr-information-box>
      Sign below to confirm the submission details and email to Ministry of
      Health.
    </pr-information-box>

    <pt-signature-input [formControl]="signatureCtrl" />

    <div class="flex flex-col gap-2">
      <span class="font-bold opacity-90">Attachments</span>
      <div class="text-primary-500 flex cursor-pointer gap-2 text-xs">
        <div (click)="mohService.addPatientMediaAttachments(fundingRequest)">
          Add from patient media
        </div>
        @if ((preApprovalAttachments$ | async)?.length) {
          <span class="text cursor-auto text-black">|</span>
          <div (click)="addAttachmentsFromApprovalRequest()">
            Add from Prior Approval Request
          </div>
        }
      </div>

      <pt-attachments
        [attachments]="attachments()"
        [uploadPath]="storagePath"
        (attachmentAdded)="addAttachment($event)"
        (attachmentRemoved)="removeAttachment($event)"
      />
    </div>

    <pt-buttons-container class="self-end">
      <pt-loader-button
        type="flat"
        color="primary"
        [loading]="loading()"
        [disabled]="loading() || !signatureCtrl.valid"
        (click)="submit()"
      >
        Send Forms
      </pt-loader-button>
    </pt-buttons-container>
  </div>

  <div
    class="col-span-3 flex flex-col border border-solid border-gray-300 bg-gray-100 p-3"
  >
    <pr-moh-form-viewer [forms]="forms" [immutable]="false" />
  </div>
</div>
